import baseLogic from '../backboneUser/willUpdate_identity_backboneUser_setPassword';
import { constants } from 'lib_ui-services';

export default {
    ...baseLogic,
    relation: 'user',
    useCaseIds: [constants.useCaseIds.FREIGHT_RUNNER]
};
